export const initialState = {
  user: null,
  loading: {},
  errors: {},
  common: {},
  showBanners: {},
  settings: {
    locale: null,
    clientIp: null,
    getCtx: () => {},
  },
};
